export default __webpack_public_path__ + "static/media/doubleCorona.35c1e8d4.png";